const isRecord = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
export const findNewestPaymentRead = (history, transactionId) => {
    for (const message of [...history].reverse()) {
        for (const part of [...message.parts].reverse()) {
            if (part.state !== "output-available" || !isRecord(part.output) || "error" in part.output) {
                continue;
            }
            const output = part.output;
            if (part.type === "tool-getPayment" && output.id === transactionId) {
                return output;
            }
            if (part.type === "tool-listPayments" &&
                !output.truncated &&
                output.nextCursor === null &&
                Array.isArray(output.payments) &&
                output.payments.length === 1 &&
                isRecord(output.payments[0]) &&
                output.payments[0].transactionId === transactionId &&
                isRecord(output.paymentDetail) &&
                !("error" in output.paymentDetail) &&
                !output.paymentDetail.truncated &&
                output.paymentDetail.id === transactionId) {
                return output.paymentDetail;
            }
        }
    }
    return null;
};
